import { EntitlementActionKind } from './actions';
export const entitlementReducer = (state, { type, payload }) => {
    switch (type) {
        case EntitlementActionKind.ModifyEntitlement: {
            return { ...payload };
        }
        default:
            return state;
    }
};
